import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { NeritClinSystemApiEnum } from 'submodules/neritclin-sdk/common/NeritClinSystemApiEnum'
import { EnvironmentEnum } from 'submodules/nerit-framework-utils/utils/enums/EnvironmentEnum'
import { AppConfig } from 'config/AppConfig'
import { AuthActions } from 'app/utils/AuthActions'

/**
 * Class especifica do projeto com informacoes necessarios para o projeto.
 */
export class NeritFrameworkProjectConfig {

    static APP_VERSION = '20230323.1'
    static PROJECT_NAME = 'Portal - NeritClin'

    private constructor() {}

    static isDev(): boolean {
        return AppConfig.getInstance().environment === EnvironmentEnum.DEV
    }

    static isHom(): boolean {
        return AppConfig.getInstance().environment === EnvironmentEnum.HOM
    }

    static async formatApiBaseUrl(config: RequestConfigTP): Promise<string> {

        if (!config.headers)
            config.headers = []

        let baseurl = config.url

        if (config.baseUrlType === NeritClinSystemApiEnum.NERITCLIN_API)
            baseurl = `${AppConfig.getInstance().apiBaseUrl}/${config.url}`

        return baseurl
    }

    static onUnauthorized(): void {
        AuthActions.onUnauthorizedRequestResponse()
    }

    static notifyApi(type: 'success' | 'error', title: string, msg: any): void {

        if (type === 'error')
            NotificationHelper.error(title, msg)
        else
            NotificationHelper.success(title, msg)
    }

}
